import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPlannerDetailResponse } from '@/api/type/types';

interface getPlannerDetailProps {
  plannerId: string;
}
export const getPlannerDetail = async ({
  plannerId,
}: getPlannerDetailProps) => {
  const res = await api.get<ApiResponseType<GetPlannerDetailResponse>>(
    `/api/web/admins/partners/planners/${plannerId}`
  );
  return res.data;
};
